<template>
    <div class="grid-content">
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="AWS Access Key"
                v-model="cred.key"
                :validate="$v.cred.key"
                help-text="Your AWS access key ID."/>
        </div>
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="AWS Secret Key"
                v-model="cred.secret"
                password
                :validate="$v.cred.secret"
                help-text="Your AWS secret access key."/>
        </div>
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="AWS Region"
                v-model="cred.region"
                :validate="$v.cred.region"
                help-text="Your AWS region name, e.g. us-west-2"/>
        </div>
        <div class="grid-item grid-item-half grid-item-break-half">
            <r-input
                label="Configuration Set Name"
                v-model="cred.configurationSetName"
                :validate="$v.cred.configurationSetName"
                help-text="The configuration set name which will be used durring email sending."/>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import BaseCredentials from './base-credentials';

    export default {
        name: 'aws-ses',
        extends: BaseCredentials,
        validations: {
            cred: {
                key: {required},
                secret: {required},
                region: {required},
                configurationSetName: {required},
            },
        },
        methods: {
            getValidationAggregate() {
                return {
                    name: 'aws-ses',
                    beforeValidation: () => this.isActiveType && this.$v.$touch(),
                    rules: () => (this.isActiveType ? [
                        {
                            name: `The AWS access key is required.`,
                            delegate: () => this.$v.cred.key.$error,
                        },
                        {
                            name: `The AWS secret access key is required.`,
                            delegate: () => this.$v.cred.secret.$error,
                        },
                        {
                            name: `The AWS region is required.`,
                            delegate: () => this.$v.cred.region.$error,
                        },
                        {
                            name: `The configuration set name is required.`,
                            delegate: () => this.$v.cred.configurationSetName.$error,
                        },
                    ] : []),
                };
            },
        },
    };
</script>

<style scoped>

</style>
